import { useTranslation } from 'react-i18next';

import { ButtonClearFilters } from '@/ui-kit/table-filters/ButtonClearFilter';
import { FormFilters } from '@/ui-kit/table-filters/FormFilters';
import { parseBasesPeriod, PeriodFilter } from '@/ui-kit/table-filters/PeriodFilter';
import { SearchFilter } from '@/ui-kit/table-filters/SearchFilter';
import { SelectFilter } from '@/ui-kit/table-filters/SelectFilter';

import { TAllCardsFiltersFields } from '@/features/cards/store/types/agent-card.types';

export interface IAllCardsFiltersProps {
  fields: TAllCardsFiltersFields;
  clearFunction?: () => void;
}

export function AllCardsFilters({ fields, clearFunction }: IAllCardsFiltersProps) {
  const { t } = useTranslation();

  return (
    <FormFilters data-testid="allCards-filters">
      <SearchFilter
        value={fields.search.value}
        options={fields.search.options}
        onChange={fields.search.handleChange}
        placeholder={t('components.molecules.search.placeholder')}
      />
      <SelectFilter field={fields.status} label={t('pages.currentProfiles.cards.card.statusCode')} />
      <SelectFilter field={fields.type} label={t('pages.currentProfiles.cards.card.cardType')} />
      <PeriodFilter
        field={fields.createdDate}
        label={t('components.filters.date.creationDate')}
        selectBase={parseBasesPeriod(t)}
      />
      {!!clearFunction ? <ButtonClearFilters onClick={() => clearFunction()} /> : <></>}
    </FormFilters>
  );
}
